<ng-template #levelCellTemplate let-row>
  <span class="c-tag" [class.otr-tag--ot1]="row.level === Level.OT1" [class.otr-tag--ot2]="row.level === Level.OT2">
    {{ levelLabel(row.level) }}
  </span>
</ng-template>

@if (!hasPortContext()) {
  <div class="otr-empty-state u-card">
    <p>{{ 'portOvertimeRules.missingContext.message' | translate }}</p>
    <button type="button" class="c-btn c-btn--stroke" (click)="goBackToPorts()">
      <span class="icon-arrow-left"></span>
      {{ 'portOvertimeRules.missingContext.backToPorts' | translate }}
    </button>
  </div>
} @else {
  <div class="otr-toolbar">
    <div class="otr-toolbar__left">
      <button type="button" class="c-btn c-btn--stroke" (click)="goBackToPorts()">
        <span class="icon-arrow-left"></span>
        {{ 'portOvertimeRules.actions.backToPorts' | translate }}
      </button>
      <button type="button" class="c-btn" (click)="openCreateRule()">
        {{ 'portOvertimeRules.actions.addRule' | translate }}
      </button>
    </div>

    <div class="otr-view-toggle">
      <core-generic-button [config]="clockViewButtonConfig()" (buttonClick)="setViewMode('clock')"></core-generic-button>
      <core-generic-button [config]="listViewButtonConfig()" (buttonClick)="setViewMode('list')"></core-generic-button>
    </div>
  </div>

  @if (viewMode() === 'clock') {
    <app-overtime-clock [rules]="rules()" (ruleClick)="openRuleById($event)" />
  } @else {
    <core-generic-table
      [dataInput]="sortedRules()"
      [columns]="ruleColumns()"
      [actions]="[]"
      [customActions]="ruleCustomActions()"
      [showFilter]="false"
      [showSelection]="false"
      [showActions]="true"
      [showCreateButton]="false"
      [enablePagination]="false"
      [listTitle]="headerTitleText()"
      [listSubTitle]="headerSubtitleText()"
      class="o-layout__section c-table--scroll">
    </core-generic-table>
  }

  <core-generic-modal
    [isOpen]="ruleFormOpen()"
    [title]="editingRuleId() ? ('portOvertimeRules.modals.editTitle' | translate) : ('portOvertimeRules.modals.addTitle' | translate)"
    [mode]="ruleModalMode()"
    [data]="ruleDraft"
    [fields]="ruleModalFields()"
    (save)="onRuleModalSave($event)"
    (close)="closeRuleForm()">
  </core-generic-modal>
}
